var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9,26.832h-.666a13.718,13.718,0,0,1-9.454-4.061A13.256,13.256,0,0,1,0,13.434a13.434,13.434,0,1,1,13.9,13.4Zm-.536-5.023c.142,0,.309.009.47.025A8.438,8.438,0,1,0,4.968,13.4a8.4,8.4,0,0,0,8.1,8.433A1.166,1.166,0,0,1,13.363,21.809Z",
    transform: "translate(26.602 18.267)",
    fill: "#bf8d46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M24.979,26.85a35.737,35.737,0,0,1-24.168-9.4,2.52,2.52,0,0,1-.8-2.1c.437-3.989,2.924-7.683,7-10.4A32.774,32.774,0,0,1,24.99,0,32.65,32.65,0,0,1,42.943,4.95c4.082,2.753,6.569,6.447,7,10.4a2.386,2.386,0,0,1-.8,2.1A35.733,35.733,0,0,1,24.979,26.85Zm.007-21.866a27.844,27.844,0,0,0-15.208,4.1,10.694,10.694,0,0,0-4.533,5.6,30.776,30.776,0,0,0,19.734,7.167A30.77,30.77,0,0,0,44.71,14.682a10.9,10.9,0,0,0-4.566-5.6A27.6,27.6,0,0,0,24.986,4.984Z",
    transform: "translate(15.025 48.984)",
    fill: "#bf8d46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M80,0V80H0V0Z",
    fill: "#bf8d46",
    opacity: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M35.832,71.667A35.833,35.833,0,1,1,71.667,35.832,35.874,35.874,0,0,1,35.832,71.667ZM35.832,5A30.833,30.833,0,1,0,66.666,35.832,30.866,30.866,0,0,0,35.832,5Z",
    transform: "translate(4.167 4.167)",
    fill: "#bf8d46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile_circle.d3e79586cb3ce703edc0dc90414c3d8a.svg";
export { ForwardRef as ReactComponent };